import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux';

import { reduxStore } from './store';

export type TStore = ReturnType<typeof reduxStore.getState>;
export type TAppDispatch = typeof reduxStore.dispatch;

export const useAppDispatch = () => useDispatch<TAppDispatch>();
export const useAppSelector: TypedUseSelectorHook<TStore> = useSelector;
